import { shallowMount } from "@vue/test-utils";
import HelpTooltip from "@/components/core/HelpTooltip";

describe("HelpTooltip component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(HelpTooltip);
  });

  it("Renders del component HelpTooltip", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
